import { render, staticRenderFns } from "./app-version.vue?vue&type=template&id=be2dc39c&scoped=true&"
import script from "./app-version.vue?vue&type=script&lang=js&"
export * from "./app-version.vue?vue&type=script&lang=js&"
import style0 from "./app-version.vue?vue&type=style&index=0&id=be2dc39c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2dc39c",
  null
  
)

export default component.exports